import { CountryEntity } from 'api/types/entity';
import { useTranslation } from 'libs/i18n';
import { AddressFields, Section } from 'modules/client/common/components';
import { DocumentsTableFeature } from 'modules/client/common/feature';

interface Props {
  countriesLoading?: boolean;
  countries: CountryEntity[];
  enabledFiles?: boolean;
}

export const CompanyRegistrationAddressSection = ({
  countriesLoading,
  countries,
  enabledFiles,
}: Props) => {
  const { t } = useTranslation();

  return (
    <Section
      datax="companyRegistrationAddressSection"
      title={t('client.legal.companyRegistrationAddress.titleRegistration')}
    >
      <AddressFields
        countries={countries}
        countriesLoading={countriesLoading}
        variant="companyRegistrationAddress"
      />
      {enabledFiles && (
        <DocumentsTableFeature name="companyRegistrationAddress.confirmationFiles" />
      )}
    </Section>
  );
};
